import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Card } from "@/components/ui/card";
import ModelTab from "./ModelTab";
import TranscriberTab from "./TranscriberTab";
import VoiceTab from "./VoiceTab";
import TelephonyTab from "./TelephonyTab";
import RegionTab from "./RegionTab";
import BargeInTab from "./BargeInTab";

interface AgentTabProps {
  // The assistant's organization, for the Region section's organization default.
  organizationId?: string;
}

export default function AgentTab({ organizationId }: AgentTabProps = {}) {
  return (
    <Card className="border-none shadow-none bg-transparent">
      <Accordion type="single" collapsible className="w-full space-y-4">
        <AccordionItem value="model" className="border rounded-lg bg-card shadow-card">
          <AccordionTrigger className="px-4">
            <div className="flex flex-col items-start">
              <h3 className="text-lg font-semibold">Model Configuration</h3>
              <p className="text-sm text-muted-foreground">
                Configure the language model and basic settings for your
                assistant
              </p>
            </div>
          </AccordionTrigger>
          <AccordionContent className="px-4 pb-4">
            <ModelTab />
          </AccordionContent>
        </AccordionItem>

        <AccordionItem value="stt_provider" className="border rounded-lg bg-card shadow-card">
          <AccordionTrigger className="px-4">
            <div className="flex flex-col items-start">
              <h3 className="text-lg font-semibold">
                Transcriber Configuration
              </h3>
              <p className="text-sm text-muted-foreground">
                Configure speech-to-text capabilities for your assistant using
                providers like OpenAI, Deepgram, Groq, and more
              </p>
            </div>
          </AccordionTrigger>
          <AccordionContent className="px-4 pb-4">
            <TranscriberTab />
          </AccordionContent>
        </AccordionItem>

        <AccordionItem value="voice" className="border rounded-lg bg-card shadow-card">
          <AccordionTrigger className="px-4">
            <div className="flex flex-col items-start">
              <h3 className="text-lg font-semibold">Voice Configuration</h3>
              <p className="text-sm text-muted-foreground">
                Configure ElevenLabs text-to-speech capabilities for your
                assistant
              </p>
            </div>
          </AccordionTrigger>
          <AccordionContent className="px-4 pb-4">
            <VoiceTab />
          </AccordionContent>
        </AccordionItem>

        <AccordionItem value="telephony" className="border rounded-lg bg-card shadow-card">
          <AccordionTrigger className="px-4">
            <div className="flex flex-col items-start">
              <h3 className="text-lg font-semibold">Telephony Configuration</h3>
              <p className="text-sm text-muted-foreground">
                Choose the carrier that places this assistant's V2 phone calls
              </p>
            </div>
          </AccordionTrigger>
          <AccordionContent className="px-4 pb-4">
            <TelephonyTab />
          </AccordionContent>
        </AccordionItem>

        <AccordionItem value="region" className="border rounded-lg bg-card shadow-card">
          <AccordionTrigger className="px-4">
            <div className="flex flex-col items-start">
              <h3 className="text-lg font-semibold">Region</h3>
              <p className="text-sm text-muted-foreground">
                Choose the region of the server that places this assistant's V2 calls,
                or follow the organization default
              </p>
            </div>
          </AccordionTrigger>
          <AccordionContent className="px-4 pb-4">
            <RegionTab organizationId={organizationId} />
          </AccordionContent>
        </AccordionItem>

        <AccordionItem value="barge-in" className="border rounded-lg bg-card shadow-card">
          <AccordionTrigger className="px-4">
            <div className="flex flex-col items-start">
              <h3 className="text-lg font-semibold">Interruptions</h3>
              <p className="text-sm text-muted-foreground">
                How the assistant handles being interrupted by the caller
              </p>
            </div>
          </AccordionTrigger>
          <AccordionContent className="px-4 pb-4">
            <BargeInTab />
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </Card>
  );
}
